import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { CierreLayout } from './CierreLayout';
import { CierreDiarioView } from './CierreDiarioView';
import { CierreMensualView } from './CierreMensualView';
import { CierreAnualView } from './CierreAnualView';

/**
 * Rutas bajo `/cierre/*` (React Router relativo al padre en App).
 */
export const CierreShell: React.FC = () => {
  return (
    <Routes>
      <Route element={<CierreLayout />}>
        <Route index element={<CierreDiarioView />} />
        <Route path="dia/:fecha" element={<CierreDiarioView />} />
        <Route path="mensual" element={<CierreMensualView />} />
        <Route path="anual" element={<CierreAnualView />} />
      </Route>
    </Routes>
  );
};
